<template>
  <div>
    <agile-table
      :data-type="'customers'"
      :data="customers"
      :tableMeta="tableMeta"
      :rowMeta="rowMeta"
      :filter-meta="filterMeta"
      :action-meta="actionMeta"
      :column-meta="columnMeta"
      @rowAction="rowAction"
      @fieldAction="fieldAction" />
    <new-button @clicked="openCustomerModal" />
    <slideout-panel />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import NewButton from '@/components/actions/CreateNewButton'
import AgileTable from '@/components/table/AgileTable'
import CustomerModal from '@/components/modals/CustomerModal'

export default {
  components: {
    NewButton,
    AgileTable
  },

  data () {
    return {
      debounceDelay: process.env.DEBOUNCE_DELAY,

      tableMeta: {
        headingIcon: 'fa-building'
      },

      rowMeta: {
        rowClass: (row) => {
          if (row.paymentRemark) {
            return 'agile-table-red-row'
          }
        }
      },

      filterMeta: [{
        fieldId: 'name',
        type: 'string',
        label: 'Kund'
      }, {
        fieldId: 'fortnoxCustomerNumber',
        type: 'string',
        label: 'Fortnox kund-nr.'
      }
      /*, {
        fieldId: 'invoiceEmail',
        type: 'string',
        label: 'Fakturamail'
      }
      */
      ],

      columnMeta: {
        hasActions: true,
        items: [{
          fieldId: 'name',
          label: 'Kund'
        },
        {
          fieldId: 'paymentTermDays',
          label: 'Bet.villkor',
          dataType: 'days'
        },
        {
          fieldId: 'numberOfProjects',
          label: 'Projekt'
        },
        {
          fieldId: 'planned',
          label: 'Planerade'
        },
        {
          fieldId: 'registered',
          label: 'Registrerade'
        },
        {
          fieldId: 'invoiced',
          label: 'Fakturerade'
        },
        {
          fieldId: 'fortnoxCustomerNumber',
          label: 'Fortnox kund-nr.'
        }]
      },

      actionMeta: {
        type: 'buttons',
        items: [{
          label: 'Ändra',
          action: 'updateCustomer',
          iconClass: 'fal fa-pen'
        }]
      }
    }
  },

  watch: {
    'customers.filter': {
      handler () {
        this.$store.state.customers.all.currentPage = 1
        this.getListData()
      },
      deep: true
    }
  },

  computed: {
    ...mapState({
      customers: state => state.customers.all
    })
  },

  methods: {
    ...mapActions('customers', ['initialize', 'getListData', 'delete']),

    rowAction (action, customer) {
      switch (action) {
        case 'updateCustomer':
          this.openCustomerModal(customer.customerId)
          break
        case 'deleteCustomer':
          this.deleteCustomer(customer)
          break
        default:
          this.$alert(action + ' is not defined!')
          break
      }
    },

    fieldAction (action, customer) {
      switch (action) {
        default:
          this.$alert(action + ' is not defined!')
          break
      }
    },

    openCustomerModal (id) {
      this.$panel(CustomerModal, { id })
    },

    deleteCustomer (customer) {
      this.$confirm('Radera kund', 'Är du säker på att du vill radera kunden ' + customer.name + '?').then((result) => {
        if (result.value) {
          this.delete(customer.customerId)
          this.getListData(1)
        }
      })
    }
  },

  created () {
    this.initialize()

    if (this.$store.state.auth.user.role === 'SuperAdmin' || this.$store.state.auth.user.role === 'Developer') {
      this.actionMeta.items.push({
        label: 'Radera',
        action: 'deleteCustomer',
        iconClass: 'fal fa-trash'
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/Admin/Customer/CustomersPage.vue